import cn from 'classnames';
import { AttributeOption } from 'models/AttributeOption';
import connect from 'components/Shared/connect';
import { getConfiguratorVariables, getConfiguratorConstraint } from 'views/ProductPage/selector';
import { onSelectValue } from 'views/ProductPage/configurators/actions';
import { ChangeEventHandler } from 'react';
import { InputProps } from 'components/Shared/Form';
import { LabeledInput } from 'components/Shared/Form/LabeledInput/themes/BGH';
import { IConstraint } from 'models/IConstraint';
import {
  isMinConstraint,
  isMaxConstraint,
  isMinMaxConstraint
} from 'views/ProductPage/configurators/selector';
import styles from './style.scss';

type OwnProps = AttributeOption &
  Partial<Omit<InputProps, 'onChange' | 'onBlur' | 'type'>> & {
    onBlur?: (value: string) => void;
    onChange?: (value: string) => void;
  };
interface MergedProps extends OwnProps {
  value: string;
  onChange: (value: string) => void;
  min?: number;
  max?: number;
}
interface StateProps {
  inputs: { [key: string]: string };
  constraints: IConstraint[];
}

const getMinMax = ({
  constraints,
  attributeId
}: {
  constraints: IConstraint[];
  attributeId: string;
}) => {
  const constraint = constraints.find(c => c.attribute === attributeId);
  let min: number | undefined;
  let max: number | undefined;

  if (isMinConstraint(constraint)) {
    min = constraint.value;
  } else if (isMaxConstraint(constraint)) {
    max = constraint.value;
  } else if (isMinMaxConstraint(constraint)) {
    min = constraint.min;
    max = constraint.max;
  }

  return { min, max };
};

export const NumericInput = connect<MergedProps, OwnProps, StateProps>(
  state => ({
    inputs: getConfiguratorVariables(state.currentPage),
    constraints: getConfiguratorConstraint(state.currentPage)
  }),
  (dispatch, props) => ({
    onChange: (value: string) => dispatch(onSelectValue(props.id, value))
  }),
  ({ inputs, constraints, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    ...getMinMax({ constraints, attributeId: props.id }),
    value: inputs[props.id] || ''
  })
)((option: MergedProps) => {
  const onChange: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
    option.onChange(value);
  };
  const onBlur: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) =>
    option.onBlur && option.onBlur(value);

  return (
    <LabeledInput
      className={cn(styles.numericInput)}
      type="number"
      value={option.value}
      placeholder={option.placeholder}
      label={option.name}
      onChange={onChange}
      onBlur={onBlur}
      unit={option.unit}
      min={option.min}
      max={option.max}
      tooltip={option.toolTip}
      inputMode="numeric"
    />
  );
});
